import template from './graph.html';
import dagre from 'dagre';
const Snap = require('imports?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js');

/**
 * Componente que grafica el grafo de familias de productos
 */
export let GraphComponent = {
  templateUrl: template,
  selector: 'graph',
  bindings: {
    translations: '=',
    onEdit: '&',
    onAddChild: '&',
    onRemove: '&',

    // objeto del tipo {nodos: [...], aristas: [...]}
    data: '<'
  },
  controller: GraphCtrl,
  controllerAs: 'vm'
};

GraphCtrl.$inject = ['$element', '$timeout', '$compile', '$scope', '$uibModal'];

function GraphCtrl($element, $timeout, $compile, $scope, $uibModal) {
  Object.assign(this, { $element, $compile, $scope, $uibModal });
  this.renderGraph = renderGraph.bind(this);
  this.addChild = addChild.bind(this);
  this.edit = edit.bind(this);
  this.remove = remove.bind(this);
  this.$postLink = () => {
    $timeout(this.renderGraph);
  };
  this.$onChanges = () => this.renderGraph();
}


function renderGraph() {
  let longitud = 30;
  let longitudNombre = 18;
  if (!this.data || !this.data.nodos) {
    return;
  }

  this.$element.find('svg').children().detach();
  this.nodesMap = {};
  // Creamos un grafo dirigido
  var g = new dagre.graphlib.Graph();
  g.setGraph({});
  g.setDefaultEdgeLabel(function() { return {}; });

  // agregamos los nodos del grafo
  this.data.nodos.forEach(nodo => {
    let descripcion = '';
    if (nodo.descripcion)
      descripcion = nodo.descripcion.length > longitud ? nodo.descripcion.substring(0, longitud) + '...' : nodo.descripcion;

    let nombre = nodo.nombre.length > longitudNombre ? nodo.nombre.substring(0, longitudNombre) + '...' : nodo.nombre;
    g.setNode(nodo.id, { label: `${nodo.codigo} - ${nombre}`, descripcion, width: 250, height: 35 });
    this.nodesMap[nodo.id] = nodo;
  });

  // agregamos las aristas del grafo
  if (this.data.aristas) {
    this.data.aristas.forEach(arista => {
      g.setEdge(arista.from.id, arista.to.id);
    });
  }
  dagre.layout(g);

  // dibujamos el grafo
  let s = Snap('#graph');
  g.nodes().forEach(id => {
    let node = g.node(id);
    // rectangulo que representa un nodo
    s.rect(node.x, node.y, node.width, node.height).attr({
      fill: '#D6EDEE',
      stroke: '#60544F',
      strokeWidth: 2,
      key: id
    });

    // linea divisoria entre la cabecera y el cuerpo
    // s.line(node.x, node.y + 30, node.x + node.width, node.y + 30).attr({
    //   stroke: '#60544F',
    //   strokeWidth: 2
    // });

    let path = s.path(`M ${node.x} ${node.y + 20} L ${node.x + node.width} ${node.y + 20}`).attr({
      stroke: 'transparent',
      strokeWidth: 2,
      id
    });

    s.text(0, 0, node.label).attr({
      color: '#414C59',
      fontSize: '15px',
      textpath: path,
      textAnchor: 'middle'
    }).textPath.attr({
      startOffset: '50%'
    });



    // let path2 = s.path(`M ${node.x} ${node.y + 40} L ${node.x + node.width} ${node.y + 40}`).attr({
    //   stroke: 'transparent',
    //   strokeWidth: 4,
    //   id
    // });


    // s.text(0, 400, node.descripcion).attr({
    //   color: '#414C59',
    //   fontSize: '12px',
    //   textpath: path2,
    //   textAnchor: 'left'
    // }).textPath.attr({
    //   startOffset: '10%'
    // });

    // agregamos los botones
    // let rectPos = $(`rect[key=${id}]`).first().offset();
    // let parentPos = this.$element.parent().offset();
    // const top = (rectPos.top - parentPos.top) + 100;
    // const left = (rectPos.left - parentPos.left) + 40;

    // let editStyle = `position: absolute; top: ${top}px; left: ${left}px`;
    // let editBtn = '<button type="button" class="btn btn-success btn-sm"' + `style="${editStyle}"` + 'title="' + 'Editar familia' + `" ng-click="vm.edit(${id})"> <span class="glyph-icon icon-pencil" style="top: -8px;"></span></button>`;
    // this.$element.append(this.$compile(editBtn)(this.$scope)[0]);

    // let addStyle = `position: absolute; top: ${top}px; left: ${left + 45}px`;
    // let addBtn = '<button type="button" class="btn btn-primary btn-sm"' + `style="${addStyle}"` + 'title="' + 'Agregar hijo' + `" ng-click="vm.addChild(${id})"> <span class="glyph-icon icon-plus" style="top: -8px;"></span></button>`;
    // this.$element.append(this.$compile(addBtn)(this.$scope)[0]);

    // let removeStyle = `position: absolute; top: ${top}px; left: ${left + 90}px`;
    // let removeBtn = '<button type="button" class="btn btn-danger btn-sm"' + `style="${removeStyle}"` + 'title="' + 'Eliminar familia' + `" ng-click="vm.remove(${id})"> <span class="glyph-icon icon-trash" style="top: -8px;"></span></button>`;
    // this.$element.append(this.$compile(removeBtn)(this.$scope)[0]);

    // let removeStyle = `position: absolute; top: ${top}px; left: ${left}px`;
    // let removeBtn = `<div class="descripcion-nodo" style="${removeStyle}">${node.descripcion}</div>`;
    // this.$element.append(this.$compile(removeBtn)(this.$scope)[0]);
  });

  g.edges().forEach(e => {
    let from = g.node(e.v);
    let to = g.node(e.w);
    s.line(from.x + from.width / 2, from.y + from.height, to.x + to.width / 2, to.y).attr({
      stroke: '#60544F',
      strokeWidth: 2
    });
  });
}

/**
 * Agrega un hijo a la familia de producto
 * 
 * @param {number} id - El ID del padre
 */
function addChild(id) {
  this.onAddChild({ padre: this.nodesMap[id] });
}

/**
 * Despliega el formulario de edición de familia de producto
 * 
 * @param {number} id - El ID de la familia
 */
function edit(id) {
  this.onEdit({ familia: this.nodesMap[id] });
}

/**
 * Elimina la familia de producto
 * 
 * @param {number} id - El ID de la familia
 */
function remove(id) {
  let vm = this;
  let scope = this.$scope;
  scope.disableButton = false;
  scope.selectedItemId = id;
  scope.tituloModal = 'Confirmación de Borrado';
  scope.mensajeModal = 'Esta operación eliminará el registro seleccionado. ¿Desea continuar?';
  scope.modalInstance = this.$uibModal.open({
    template: '<div class="modal-header">' + '<h3 class="modal-title">{{::tituloModal}}</h3>' + '</div>' + '<div class="modal-body">{{::mensajeModal}}</div>' + '<div class="modal-footer">' + '<button class="btn btn-primary" ng-disabled="disableButton" ng-click="ok(selectedItemId)">Aceptar</button>' + '<button class="btn btn-warning" ng-disabled="disableButton" ng-click="cancel()">Cancelar</button>' + '</div>',
    scope: scope
  });

  scope.cancel = function() {
    scope.modalInstance.dismiss('cancel');
  };
  scope.ok = (id) => {
    scope.modalInstance.dismiss('cancel');
    vm.onRemove({ familia: this.nodesMap[id] });
  };
}


// WEBPACK FOOTER //
// ./src/core/components/graph/graph.component.js